<div class="pt-4 pb-3 px-md-3 px-lg-0" id="dashboard-page">
  <div class="hello-user my-3">
    <label for="hello-user">Olá {{ dependentData?.name.split(" ")[0] }}!</label>
  </div>
  <div class="row g-3">
    @if(plan){
    <!-- Visivel apenas no mobile -->

    <div class="col-12 col-xl-8">
      <app-plan-dependent-card 
        [plan]="plan" 
        [memberShipCard]="memberShipCard" 
        [dependentData]="dependentData"
        [memberData]="memberData">
      </app-plan-dependent-card>
    </div>
    }

    <!-- Card Checkin -->
    <div class="col-12 col-md-6 col-xl-4" [ngStyle]="styles">
      <div class="card checkin-card">
        <div class="card-body d-grid">
          <div *ngIf="ingressosCheckIn.length === 0 && nextGame.length === 0" class="card-title">
            Check-in
          </div>
          @if (ingressosCheckIn.length > 0) {
          <div id="matchCarouselCheckin" class="carousel slide m-0 h-100" data-bs-ride="carousel">
            <!-- Indicadores do carousel -->
            <ol class="carousel-indicators" *ngIf="showIndicators">
              <li *ngFor="let game of ingressosCheckIn; let i = index" [class.active]="i === 0"
                data-bs-target="#matchCarouselCheckin" [attr.data-bs-slide-to]="i"></li>
            </ol>

            <!-- Slides do carousel -->
            <div class="carousel-inner h-100">
              <div class="carousel-item h-100 text-center" *ngFor="let game of ingressosCheckIn; let i = index"
                [class.active]="i === 0">
                <div class="h-100 d-flex flex-column justify-content-between align-items-center">
                  <div>
                    <div class="match-date mb-3">
                      <span>{{
                        commonService.getInvertedDate(game.waveGame.gameDate)
                        }}
                        às {{ game.waveGame.gameTime }}</span>
                    </div>
                    <div class="match-location mb-3">
                      <p>{{ game.waveGame.championship.title }}</p>
                      <p class="d-md-flex mx-2">/</p>
                      <p>{{ game.waveGame.location.name }}</p>
                    </div>
                  </div>
                  <div class="match d-flex justify-content-center">
                    @if(game.waveGame.mandatorSoccerTeam){

                    <div class="row">
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="teamLogo" alt="team 1" />
                          <div class="club-name">
                            <span>{{ game.waveGame.soccerTeamName }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="versus mx-1 align-content-center">
                          <span>X</span>
                        </div>
                      </div>
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="getAdversaryLogo(game)" alt="team 2" />
                          <div class="club-name">
                            <span>{{ game.waveGame.adversary.name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    } @else {

                    <div class="row">
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="getAdversaryLogo(game)" alt="team 2" />
                          <div class="club-name">
                            <span>{{ game.waveGame.adversary.name }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="versus mx-1 align-content-center">
                          <span>X</span>
                        </div>
                      </div>
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="teamLogo" alt="team 1" />
                          <div class="club-name">
                            <span>{{ game.waveGame.soccerTeamName }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>

                  <div class="mt-4">
                    <app-button *ngIf="isActiveCheckins" [style]="'--bs-btn-padding-x: 1.4em;'"
                      [buttonOptions]="checkinButtonOptions" class="app-button"
                      (buttonClick)="openCheckInModal(game.id)"></app-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Controles do carousel -->
            <button class="carousel-control-prev" type="button" data-bs-target="#matchCarouselCheckin"
              data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Anterior</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#matchCarouselCheckin"
              data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Próximo</span>
            </button>
          </div>
          } @else if (nextGame.length > 0) {
          <div id="matchCarouselCheckin" class="carousel slide m-0 h-100" data-bs-ride="carousel">
            <!-- Indicadores do carousel -->
            <ol class="carousel-indicators mb-4" *ngIf="showIndicators">
              <li *ngFor="let game of nextGame; let i = index" [class.active]="i === 0"
                data-bs-target="#matchCarouselCheckin" [attr.data-bs-slide-to]="i"></li>
            </ol>

            <!-- Slides do carousel -->
            <div class="carousel-inner h-100">
              <div class="mb-3 text-center">
                <span>
                  <strong>Próximos Jogos</strong>
                </span>
              </div>
              <div class="carousel-item h-100 text-center" *ngFor="let game of nextGame; let i = index"
                [class.active]="i === 0">
                <div class="h-100 d-flex flex-column align-items-center">
                  <div class="mt-3">
                    <div class="match-date mb-3 text-center">
                      <span>{{ commonService.getInvertedDate(game.gameDate) }} às
                        {{ game?.gameTime }}</span>
                    </div>
                    <div class="match-location mb-3">
                      <p>{{ game.championship?.title }}</p>
                      <p class="d-none d-md-flex mx-2">/</p>
                      <p>{{ game.location?.name }}</p>
                    </div>
                  </div>
                  <div class="match d-flex justify-content-center">
                    @if(game.mandatorSoccerTeam){

                    <div class="row">
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="teamLogo" alt="team 1" />
                          <div class="club-name">
                            <span>{{ game.soccerTeamName }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="versus mx-1 align-content-center">
                          <span>X</span>
                        </div>
                      </div>
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="getAdversaryLogo2(game)" alt="team 2" />
                          <div class="club-name">
                            <span>{{ game.adversary.name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    } @else {

                    <div class="row">
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="getAdversaryLogo2(game)" alt="team 2" />
                          <div class="club-name">
                            <span>{{ game.adversary.name }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-2 d-flex justify-content-center align-items-center">
                        <div class="versus mx-1 align-content-center">
                          <span>X</span>
                        </div>
                      </div>
                      <div class="col-5 d-flex justify-content-center align-items-center">
                        <div class="team px-2 px-sm-3">
                          <img [src]="teamLogo" alt="team 1" />
                          <div class="club-name">
                            <span>{{ game.soccerTeamName }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <!-- Controles do carousel -->
            <button class="carousel-control-prev" type="button" data-bs-target="#matchCarouselCheckin"
              data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Anterior</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#matchCarouselCheckin"
              data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Próximo</span>
            </button>
          </div>

          } @else {
          <div class="d-flex flex-column align-items-center h-100">
            <div class="text-center py-1 mt-3">
              <b>Sem jogos para realizar check-in</b>
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-xl-4">
      <div class="card partner-card">
        <div class="card-body row user-info">
          <div class="card-title">{{ "Dados do Dependente" | replaceText }}</div>

          <div class="custom-scrollbar" style="max-height: 15rem; overflow-y: auto">
            <div class="col-12 pb-3">
              <i class="bi bi-person-fill"></i><b> Nome:</b> {{ dependentMemberData?.name }}
            </div>
            <div class="col-12 pb-3" *ngIf="!secondaryPlanId">
              <i class="bi bi-exclamation-circle-fill"></i><b> Situação:</b>
              {{ dependentMemberData?.memberSituation?.name }}
            </div>
            <div class="col-12 pb-3" *ngIf="showContinuousMonth && dependentMemberData?.continuousMonthsCount > 0">
              <i class="bi bi-calendar-check"></i><b> Meses Ininterruptos:</b>
              {{
              dependentMemberData.continuousMonthsCount > 1
              ? dependentMemberData.continuousMonthsCount + " meses"
              : dependentMemberData.continuousMonthsCount + " mês"
              }}
            </div>
            <div class="col-12 pb-3">
              <i class="bi bi-envelope-fill"></i><b> E-mail:</b>
              {{ dependentMemberData?.emails[0]?.email }}
            </div>
            <div class="col-12 pb-3">
              <i class="bi bi-telephone-fill"></i><b> Telefone:</b>
              {{ dependentMemberData?.phones[0]?.number | phone }}
            </div>
            <div class="col-12 pb-3">
              <i class="bi bi-gender-ambiguous"></i><b> Gênero:</b>
              {{
              dependentMemberData?.gender === "M"
              ? "Masculino"
              : dependentMemberData?.gender === "F"
              ? "Feminino"
              : "Não informado"
              }}
            </div>
            <div class="col-12 pb-3 d-none d-md-block">
              <i class="bi bi-house-door-fill"></i><b> Endereço:</b>
              {{ this.getAddress() }}
            </div>
          </div>

          <app-button class="align-content-center" 
            [buttonOptions]="btnUpdateDataOptions"
            (buttonClick)="goToPartnerData()">
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-form-modal [modalId]="'modalCheckinTicket'" [modalTitle]="'Realizar Check-in'" [showCloseBtn]="false"
  [ticketData]="ingressosCheckIn" [checkinsHistory]="checkinsHistory" [limitCheckin]="limitCheckin"
  [checkinSelected]="checkinSelected" [selectInputOptions]="selectInputOptionsModal" [memberDependents]="memberDependents"
  [selectControl]="selectControlModal" [isAtLeast12]="isAtLeast12" [isSenior]="isSenior"
  (onModalConfirm)="onModalFormConfirm($event)">
</app-form-modal>

<app-confirm-modal
  [modalId]="'modalConfirm'"
  [link]="linkModalConfirm">
</app-confirm-modal>

<app-modal-change-checkin
  [modalId]="'modalChangeCheckin'"
  [pendentTicket]="pendentTicket">
</app-modal-change-checkin>

<app-choose-payment-modal
  [modalId]="'modalChoosePayment'"
  [modalTitle]="'Escolha a forma de pagamento'"
  [size]="'modal-md'"
  [modalData]="paymentModalData"
  (confirmActionChange)="onModalCheckinConfirm($event)">
</app-choose-payment-modal>

<app-modal [modalTitle]="'Atualização de Dados'" modalId="updateDataModal" [size]="'modal-xl'" [showCloseBtn]="false"
  [scrollable]="true" [modalBodyMessage]="updateMemberModalBodyMessage" modalConfirmLabel="Atualizar"
  [backdropType]="'static'" (confirmActionChange)="onUpdateDataModalConfirm()">
</app-modal>
